export const PHONE_DISPLAY = "70892 72892";
export const PHONE_TEL = "tel:+917089272892";
export const RERA = "P52100079446";
export const ADDRESS = "Kohinoor world towers, T-2, 108 Old Mumbai Pune Hwy, Pune, 411018";


export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "highlights", label: "Highlights" },
  { id: "units", label: "Units" },
  { id: "floor-plans", label: "Floor Plans" },
  { id: "location", label: "Location" },
  { id: "contact", label: "Contact" },
];

export const HIGHLIGHTS = [
  {
    n: "01",
    title: "Strategic Business Location",
    body: "Positioned in Nigdi–Pradhikaran, one of the region's established commercial hubs with seamless connectivity across PCMC.",
  },
  {
    n: "02",
    title: "Premium Retail & Office Spaces",
    body: "Contemporary spaces crafted to support growing businesses with efficient planning, natural illumination, and premium finishes.",
  },
  {
    n: "03",
    title: "Built for Visibility & Growth",
    body: "A distinctive commercial development offering strong road presence, excellent footfall potential, and lasting investment appeal.",
  },
];

export const RETAIL_SHOPS = [
  { no: "1", carpet: "487.5", salable: "731.25" },
  { no: "2", carpet: "402.1", salable: "603.2" },
  { no: "3", carpet: "396.22", salable: "594.33" },
  { no: "4", carpet: "459.19", salable: "688.78" },
  { no: "5", carpet: "1054.6", salable: "1581.9" },
  { no: "6", carpet: "371.8", salable: "557.8" },
  { no: "7", carpet: "415.59", salable: "623.39" },
  { no: "8", carpet: "454.24", salable: "681.36" },
];

export const OFFICES = [
  { no: "101, 201, 301, 401, 501, 601", carpet: "1203.9", salable: "1745.7" },
  { no: "102, 202, 302, 402, 502, 602", carpet: "398.2", salable: "577.48" },
  { no: "103, 203, 303, 403, 503, 603", carpet: "407.2", salable: "590.44" },
  { no: "104, 204, 304, 404, 504, 604", carpet: "564.3", salable: "817.84" },
  { no: "105, 205, 305, 405, 505, 605", carpet: "407.41", salable: "590.75" },
];

// In your lib/constants file
export const FLOOR_PLANS = [
  { 
    id: 1, 
    n: '01', 
    title: 'Parking Floor Plan', 
    alt: 'Parking floor plan',
    imageKey: 'parking'  // This will reference ASSETS.parking
  },
  { 
    id: 2, 
    n: '02', 
    title: 'Ground Floor Plan', 
    alt: 'Ground floor plan',
    imageKey: 'ground'   // This will reference ASSETS.ground
  },
  { 
    id: 3, 
    n: '03', 
    title: 'First Floor Plan', 
    alt: 'First floor plan',
    imageKey: 'first'    // This will reference ASSETS.first
  },
  { 
    id: 4, 
    n: '04', 
    title: 'Typical Office Floor Plan', 
    alt: 'Typical office floor plan',
    imageKey: 'typical'  // This will reference ASSETS.typical
  },
];

export const DISTANCES = [
  { place: "Akurdi Railway Station", dist: "1 km" },
  { place: "Ganesh Talav Garden", dist: "1 km" },
  { place: "PCCOE Engineering College", dist: "1.5 km" },
  { place: "Orchid International School", dist: "0.5 km" },
  { place: "Gravity Badminton Court", dist: "1 km" },
  { place: "Swimming Pool", dist: "0.5 km" },
  { place: "Old Mumbai-Pune Highway", dist: "3.9 km" },
  { place: "Expressway", dist: "4 km" },
  { place: "Hinjewadi IT Park", dist: "10 km" },
];

export const ASSETS = {
  // sticker: "/Sticker1.png",
  sticker: "/Sticker2.png",
  building: "/Building3.jpg",
  brochure: "brochure_palaash_paradise.pdf",
  parking: "/parking.png",
  ground: "/ground.png",
  first: "/first.png",
  typical: "/typical.png",
  ecorb: "/ecorb.png",
};
